import script from "./ThirdTawafPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdTawafPage.vue?vue&type=script&setup=true&lang=js"

import "./ThirdTawafPage.vue?vue&type=style&index=0&id=1111198e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1111198e"]])

export default __exports__